import { BookOpenCheck, CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@helios/ui';
import { useBibleStatus } from '@/hooks/useBibleStatus';

export function EngineeringBibleStatusCard() {
  const bible = useBibleStatus();

  return (
    <Card>
      <CardHeader className="flex-row items-center gap-3 space-y-0">
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary/15 text-primary">
          <BookOpenCheck className="h-4 w-4" aria-hidden />
        </span>
        <div>
          <CardTitle className="text-base">Engineering Bible</CardTitle>
          <CardDescription>Source of truth for architecture and standards</CardDescription>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center gap-2 text-sm">
          <CheckCircle2 className="h-4 w-4 text-success" aria-hidden />
          <span className="font-medium text-foreground">
            {bible.present ? 'Present' : 'Missing'}
          </span>
          <span className="text-muted-foreground">· version {bible.version}</span>
        </div>
        <dl className="grid grid-cols-3 gap-2 text-xs">
          <div className="rounded-lg border border-border bg-background/40 px-2.5 py-2">
            <dt className="text-muted-foreground">Status</dt>
            <dd className="mt-0.5 font-medium text-success">Committed</dd>
          </div>
          <div className="rounded-lg border border-border bg-background/40 px-2.5 py-2">
            <dt className="text-muted-foreground">Version</dt>
            <dd className="mt-0.5 font-medium text-foreground">{bible.version}</dd>
          </div>
          <div className="rounded-lg border border-border bg-background/40 px-2.5 py-2">
            <dt className="text-muted-foreground">Sprint</dt>
            <dd className="mt-0.5 font-medium text-foreground">S00</dd>
          </div>
        </dl>
        <p className="font-mono text-[11px] text-muted-foreground">{bible.location}</p>
      </CardContent>
    </Card>
  );
}
